import React, { Fragment, useEffect, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Grid, Checkbox, Tooltip, IconButton, FormLabel, Box,Paper } from '@material-ui/core';
import { useStyle } from './style';
import HelpIcon from '@material-ui/icons/Help';
import { EirSwitch } from '../eir-checkout/EirSwitch';
import { MARKETING_PREFERENCES_NOTE, MARKETING_PREFERENCES } from './constants';
import errormesages from './errormessages';

export default function EirCustomerMarketingPreferences(props){
    const { register, control, errors, clearError } = useFormContext();
    const classes = useStyle();
    const { customerInformation } = props;
    const { validation } = errormesages;
    const [contactGroupList, setContactGroupList] = useState(MARKETING_PREFERENCES);


    useEffect(() => {
        if (customerInformation != null && customerInformation.owner != null) {
            contactGroupList[1].preferenceList[0].enabled = customerInformation.contactPermission.permissionGroupResponse[1].permissions[0].enabled;
            contactGroupList[1].preferenceList[1].enabled = customerInformation.contactPermission.permissionGroupResponse[1].permissions[1].enabled;
            contactGroupList[1].preferenceList[2].enabled = customerInformation.contactPermission.permissionGroupResponse[1].permissions[2].enabled;
            contactGroupList[1].preferenceList[3].enabled = customerInformation.contactPermission.permissionGroupResponse[1].permissions[3].enabled;
            contactGroupList[1].preferenceList[4].enabled = customerInformation.contactPermission.permissionGroupResponse[1].permissions[4].enabled;
            contactGroupList[0].preferenceList[0].enabled = customerInformation.contactPermission.permissionGroupResponse[0].permissions[0].enabled;
            contactGroupList[0].preferenceList[1].enabled = customerInformation.contactPermission.permissionGroupResponse[0].permissions[1].enabled;
            contactGroupList[0].preferenceList[2].enabled = customerInformation.contactPermission.permissionGroupResponse[0].permissions[2].enabled;
            contactGroupList[0].preferenceList[3].enabled = customerInformation.contactPermission.permissionGroupResponse[0].permissions[3].enabled;
            contactGroupList[0].preferenceList[4].enabled = customerInformation.contactPermission.permissionGroupResponse[0].permissions[4].enabled;
            const preferenceIndex = contactGroupList[1].preferenceList.findIndex(
                (preference) => preference.enabled === true);
            if (preferenceIndex < 0) {
                contactGroupList[1].enabled = false;
            }
            else {
                contactGroupList[1].enabled = true;
            }

            const selectedIndex = contactGroupList[0].preferenceList.findIndex(
                (preference) => preference.enabled === true);
            if (selectedIndex < 0) {
                contactGroupList[0].enabled = false;
            }
            else {
                contactGroupList[0].enabled = true;
            }
        }


    }, []);
    const handleSwitchChange = (isChecked, contactGroup) => () => {
        const newChecked = [...contactGroupList];
        const selectedGroupIndex = newChecked.findIndex((group) => group.permission === contactGroup.permission);
        const selectedGroup = newChecked[selectedGroupIndex];
        selectedGroup.enabled = isChecked;
        if (!isChecked && selectedGroup.preferenceList) {
            selectedGroup.preferenceList.forEach((preference) => (preference.enabled = false));
        }
        setContactGroupList(newChecked);
    };

    const handleCheckboxChange = (isChecked, contactGroup, contactPreference) => () => {
        const newChecked = [...contactGroupList];
        const selectedGroupIndex = newChecked.findIndex((group) => group.permission === contactGroup.permission);
        const selectedGroup = newChecked[selectedGroupIndex];
        const preferenceIndex = selectedGroup.preferenceList.findIndex(
            (preference) => preference.permission === contactPreference.permission);

        selectedGroup.preferenceList[preferenceIndex].enabled = isChecked;
        if (isChecked) {
            selectedGroup.enabled = true;
            clearError(selectedGroup.permission);
        } else {
            if (selectedGroup.enabled) {
                const preferenceIndex = selectedGroup.preferenceList.findIndex(
                    (preference) => preference.enabled === true);
                if (preferenceIndex < 0) {
                    selectedGroup.enabled = false;
                }
            }
        }
        setContactGroupList(newChecked);
    };
    const isPreferneceChecked = (contactGroup) => () => {
        const groupList = [...contactGroupList];
        const selectedGroupIndex = groupList.findIndex((group) => group.permission === contactGroup.permission);
        const selectedGroup = groupList[selectedGroupIndex];
        if (selectedGroup.permission === '3P') {
            return true;
        }
        if (selectedGroup.enabled) {
            const preferenceIndex = selectedGroup.preferenceList.findIndex(
                (preference) => preference.enabled === true);
            if (preferenceIndex < 0) {
                return false;
            }
        }
        return true;
    }
    const tableHeader = [
        ...new Set(
            contactGroupList.flatMap((conatctGroup) =>
                conatctGroup.preferenceList ? conatctGroup.preferenceList.map((group) => group.name) : []
            )
        ),
    ];


    return (
        <Fragment>
            <Paper className={classes.contactPaper} variant='elevation' elevation={4}>
            <h2 className={classes.contactTxt}>New Products & Services</h2>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormLabel className={classes.formLabelColor}> {MARKETING_PREFERENCES_NOTE} </FormLabel>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item md={3} >
                    <Box display={{ xs: 'none', md: 'block' }} >
                        <Grid container>
                            <Grid item>
                                <Grid container spacing={2} >
                                    <Grid item key='empty' xs className={classes.tableHeader} />
                                    {contactGroupList.map((group) => (
                                        <Grid item xs={12}>
                                            <Grid container alignItems="center" spacing={1} className={classes.tableRow}>
                                                <Grid
                                                    item
                                                    key={group.name}
                                                    className={classes.contactGroupNames}
                                                >
                                                    <FormLabel className={classes.formLabelColor}> {group.name}</FormLabel>
                                                </Grid>

                                                {group.tooltip && (
                                                    <Grid item  >
                                                        <Tooltip title={group.tooltip} size="small" className={classes.marginleft}>
                                                            <IconButton color="primary" size="small" className={classes.marginleft}>
                                                                <HelpIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                )}

                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item md={3}>
                    <Box display={{ xs: 'none', md: 'block' }} >
                        <Grid container justify='center'>
                            <Grid item className={classes.tableHeader}>
                                I want to be contacted
                        </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={2} >
                                    {contactGroupList.map((group) => (
                                        <Grid item xs={12}>
                                            <Grid container spacing={1} className={classes.prefernceRow}>
                                                <Grid item>No</Grid>
                                                <Grid item>
                                                    <Controller
                                                        as={EirSwitch}
                                                        control={control}
                                                        name={group.permission}
                                                        id={group.permission}
                                                        inputRef={register}
                                                        checked={group.enabled}
                                                        onChange={([event]) =>
                                                            handleSwitchChange(Boolean(event.target.checked), group)

                                                        }
                                                        rules={{ validate: isPreferneceChecked(group) }}
                                                    />
                                                </Grid>
                                                <Grid item>Yes</Grid>
                                            </Grid>

                                        </Grid>

                                    ))}

                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item md={6}>
                    <Box display={{ xs: 'none', md: 'block' }} >
                        <Grid container>
                            <Grid item xs={12}>
                                <Grid container className={classes.centerAlign}>
                                    {tableHeader.map((headerName) => (
                                        <Grid item key={headerName} xs className={classes.prefernceHeader}>
                                            {headerName}
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    {contactGroupList.map((group) => (
                                        <Grid item xs={12}>
                                            <Grid container className={classes.prefernceRow}>
                                                {group.preferenceList.map((preference) => (
                                                    <Grid item xs >
                                                        <Controller
                                                            as={Checkbox}
                                                            control={control}
                                                            name={group.permission + preference.permission}
                                                            id={group.permission + preference.permission}
                                                            inputRef={register}
                                                            color="primary"
                                                            classes={group.enabled ? { root: classes.whiteCheckbox } : ''}
                                                            checked={preference.enabled}
                                                            onChange={([event]) =>
                                                                handleCheckboxChange(Boolean(event.target.checked), group, preference)

                                                            }
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    ))}
                                    {errors.active && errors.active.type === 'validate' && <span className={classes.serviceErrorMessage}>{validation.serviceActiveChecked}</span>}
                                    {errors.inactive && errors.inactive.type === 'validate' && <span className={classes.serviceErrorMessage}>{validation.serviceInactiveChecked}</span>}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box display={{ xs: 'block', md: 'none' }} >
                        <Grid container spacing={4}>
                            {contactGroupList.map((group) => (
                                <Grid item xs={12}>
                                    <Grid container spacing={2} justify='center'>
                                        <Grid item xs={12} >
                                            <Grid container spacing={1} className={classes.tableRow}>
                                                <Grid item>
                                                    <FormLabel className={`${classes.formLabelColor} ${classes.contactGroupNames}`}> {group.name}</FormLabel>
                                                </Grid>
                                                {group.tooltip && (
                                                    <Grid item>
                                                        <Tooltip title={group.tooltip} size="small" className={classes.permissionToolTip}>
                                                            <IconButton color="primary" size="small" >
                                                                <HelpIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                )}

                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Grid container className={classes.tableRow} spacing={1}>
                                                <Grid item xs={12}>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={7} className={classes.marginLeft}>
                                                            <FormLabel className={`${classes.preferenceName} ${classes.marginleft}`}> I want to be contacted</FormLabel>
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <Grid container spacing={1} justify='center'>
                                                                <Grid item className={classes.prefernceHeader} >No</Grid>
                                                                <Grid item className={classes.prefernceHeader}>
                                                                    <Controller
                                                                        as={EirSwitch}
                                                                        control={control}
                                                                        name={ group.permission}
                                                                        id={group.permission}
                                                                        inputRef={register}
                                                                        checked={group.enabled}
                                                                        onChange={([event]) =>
                                                                            handleSwitchChange(Boolean(event.target.checked), group)

                                                                        }
                                                                        rules={{ validate: isPreferneceChecked(group) }}
                                                                    />
                                                                </Grid>
                                                                <Grid item className={classes.prefernceHeader}>Yes</Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {group.enabled && group.preferenceList.length > 0 && (
                                            <Grid item xs={12}>
                                                <Grid container className={classes.tableRow} spacing={1}>

                                                    {group.preferenceList.map((preference) => (
                                                        <Grid item xs={6}>
                                                            <Grid container >
                                                                <Grid item>
                                                                    <Controller
                                                                        as={Checkbox}
                                                                        control={control}
                                                                        name={ group.permission + preference.permission}
                                                                        id={ group.permission + preference.permission}
                                                                        inputRef={register}
                                                                        color="primary"
                                                                        classes={{ root: classes.whiteCheckbox }}
                                                                        checked={preference.enabled}
                                                                        onChange={([event]) =>
                                                                            handleCheckboxChange(Boolean(event.target.checked), group, preference)

                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid item>
                                                                    <FormLabel className={classes.preferenceName}>{preference.name}</FormLabel>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                               
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>

                            ))}
                        </Grid>
                        {errors.active && errors.active.type === 'validate' && <span className={classes.serviceErrorMessage}>{validation.serviceActiveChecked}</span>}
                        {errors.inactive && errors.inactive.type === 'validate' && <span className={classes.serviceErrorMessage}>{validation.serviceInactiveChecked}</span>}
                    </Box>
                    <input type="hidden" ref={register} id='permissionGroupList' name='permissionGroupList' value={JSON.stringify(contactGroupList)} />

                </Grid>
            </Grid>
            </Paper>
        </Fragment >
    );
}